import { ReadonlySharedStyleMap, SharedStyle, StyleProp } from '@tldraw/tldraw'

// Taken from:
// https://github.com/tldraw/tldraw/blob/9915f2b0f60e9be9c5887ce4d6605bb577fe92b0/packages/editor/src/lib/utils/SharedStylesMap.ts#L93
export class SharedStyleMap extends ReadonlySharedStyleMap {
  protected map: Map<StyleProp<unknown>, SharedStyle<unknown>>

  constructor(entries?: Iterable<[StyleProp<unknown>, SharedStyle<unknown>]>) {
    super()
    this.map = new Map(entries)
  }

  set<T>(prop: StyleProp<T>, value: SharedStyle<T>) {
    this.map.set(prop, value)
  }

  applyValue<T>(prop: StyleProp<T>, value: T) {
    const existingValue = this.get(prop)

    // if we don't have a value yet, set it
    if (!existingValue) {
      this.set(prop, { type: 'shared', value })
      return
    }

    switch (existingValue.type) {
      case 'mixed':
        // we're already mixed, adding new values won't help
        return
      case 'shared':
        if (existingValue.value !== value) {
          // if the value is different, we're now mixed:
          this.set(prop, { type: 'mixed' })
        }
        return
      default:
        return
    }
  }
}
